import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "./../../environments/environment";

@Injectable({
	providedIn: 'root'
})
export class NoderestapiService {

	url

	constructor(private http: HttpClient) {
		this.url = environment.url
	}



	getData(data){
		return this.http.get(`https://us-central1-ecatepecapp.cloudfunctions.net/app/data/get/${data}`);
	}

	

	traerEmpresaPorNombre(empresa){
		return this.http.get(`${this.url}/get/empresapornombre/${empresa}`);
	}

	traerDepartamento(id){
		return this.http.get(`${this.url}/get/departamentos/${id}`);
	}


	

	consultarBusqueda(busqueda){
		return this.http.post(`${this.url}/busqueda/general`, busqueda)
	}


	// ===============================================================
	// ================== 		TRAER DATOS			======================
	traerSecciones(){
		return this.http.get(`${this.url}/get/secciones`)
	}

	traerColoniaComunidad(){
		return this.http.get(`${this.url}/get/colonia_comunidad`)
	}

	traerNombreRegistrante(){
		return this.http.get(`${this.url}/get/nombre_registrante`)
	}
	

	traerMejoresGestores(){
		return this.http.get(`${this.url}/get/mejores-gestores`)
	}

	traerUltimosGestores(){
		return this.http.get(`${this.url}/get/ultimos-gestores`)
	}


	// ===============================================================
	// ================== 		GENÉRICOS			======================
	traerGenericos(path){
		return this.http.get(`${this.url}/get/${path}`)
	}

	borrarGenerico(path, id){
		return this.http.delete(`${this.url}/delete/${path}/${id}`);
	}

	guardarGenerico(path, data:any) {
		return this.http.post(`${this.url}/post/${path}`, data)
	}

	updateGeneric(path, data:any) {
		return this.http.put(`${this.url}/put/${path}`, data)
	}

	getGeneric(path, id){
		return this.http.get(`${this.url}/get/${path}/${id}`);
	}

	getGenericByField(path, field){
		return this.http.get(`${this.url}/get/${path}/${field}`);
	}
	// ===============================================================
	// ================== 		REGISTROS		======================

	traerRegistro(id){
		return this.http.get(`${this.url}/get/registro/${id}`);
	}


	guardarEmpresa(empresa:any) {
		return this.http.post(`${this.url}/post/empresa`, empresa)
	}


	traerRegistrosFiltrados(filter, value){
		return this.http.get(`${this.url}/get/registros-filtrados/${filter}/${value}`);
	}

	borrarEmpresa(id){
		return this.http.delete(`${this.url}/delete/empresa/${id}`);
	}


	actualizarEmpresa(empresa:any){
		return this.http.put(`${this.url}/put/empresa`, empresa)
	}


	// ===============================================================
	// ================== 		USUARIO			======================
	
	guardarUsuario(usuario:any) {
		console.info("Ejecutando función guardarUsuario en noderestapi");
		console.log("Voy a ejectuar con el usuario: ", usuario);
		
		return this.http.post(`${this.url}/post/usuario`, usuario)
	}

	traerUsuarios(){
		return this.http.get(`${this.url}/get/usuarios`)
	}

	traerUsuario(uid){
		return this.http.get(`${this.url}/get/usuariobyuid/${uid}`)
	}

	borrarUsuario(uid){
		console.log("Se va a borrar el usuario" + uid)
		return this.http.delete(`${this.url}/delete/usuario/${uid}`);
	}

	// ===============================================================
	// ================== 		DEPARTAMENTO	======================
	
	traerDepartamentos(){
		return this.http.get(`${this.url}/get/departamentos`)
	}

	guardarDepartamento(departamento:any){
		return this.http.post(`${this.url}/post/departamentos`, departamento)
	}

	borrarDepartamento(id){
		return this.http.delete(`${this.url}/delete/departamentos/${id}`);
	}


	verificar(id){
		let jsonid = {
			id: id
		}
		return this.http.post(`${this.url}/post/verificar/`, jsonid);
	}

	desverificar(id){
		let jsonid = {
			id: id
		}
		return this.http.post(`${this.url}/post/desverificar/`, jsonid);
	}


	getCantidadRegistros(){
		return this.http.get(`${this.url}/get/cantidad-registros`);
	}

	getCantidadVerificados(){
		return this.http.get(`${this.url}/get/cantidad-verificados`);
	}
}